import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取优惠券库存列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getCouponShopPoolList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponShopPool.listCouponShopPool',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存赠送停车券
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function saveSendParking(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cart/saveSendParking',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}